import Network from '@/services/network'

export default function handleHospitalBilling() {
    const network = new Network;

    // OPD Billing
    const fetchOPDBillings = (query) => {
        return network.api('get', '/hospital/opd-billings' + query);
    }
    const showOPDBilling = (id, query) => {
        return network.api('get', '/hospital/opd-billings/' + id + query);
    }
    const storeOPDBilling = (data) => {
        return network.api('post', '/hospital/opd-billings', data);
    }
    const updateOPDBilling = (data) => {
        return network.api('put', '/hospital/opd-billings/' + data.id, data);
    }
    const returnOPDBilling = (data) => {
        return network.api('post', '/hospital/return/opd-billings', data);
    }
    const returnBillings = (data) => {
        return network.api('post', '/hospital/return/billings', data);
    }

    const editReturnBillings = (id, data) => {
        return network.api('put', `/hospital/return/billings/${id}`, data);
    }

    const bulkReturnBillings = (data) => {
        return network.api('post', '/hospital/return/bulk-billings', data);
    }

    const fetchIpdReturnableProducts = (ipdRegisterId, query) => {
        return network.api('get', `/hospital/report/ipd-statement/${ipdRegisterId}/returnable-products` + query);
    }

    const fetchIpdRegisterList = (query) => {
        return network.api('get', '/hospital/ipd-registers/all' + query);
    }

    const fetchDoctorOrders = (query) => {
        return network.api('get', '/hospital/doctor-orders' + query);
    }

    const fetchDoctorMedicineOrder = (orderId, query) => {
        return network.api('get', `/hospital/doctor-orders/${orderId}/medicines${query}`);
    }

    return {
        returnBillings,
        storeOPDBilling,
        fetchOPDBillings,
        showOPDBilling,
        updateOPDBilling,
        returnOPDBilling,
        fetchDoctorOrders,
        fetchIpdRegisterList,
        fetchDoctorMedicineOrder,
        editReturnBillings,
        bulkReturnBillings,
        fetchIpdReturnableProducts
    }
}
